import loadable from '@loadable/component'

export const Ticker = loadable(() => import('./Ticker'))
export type { TickerProps, TikerState } from './Ticker'
